import React from 'react';

import PropType from 'prop-types';

import { View } from './style';

const GenericCard = ({ children }) => (
  <View>
    {children}
  </View>
);

GenericCard.propTypes = {
  // eslint-disable-next-line react/require-default-props
  children: PropType.element,
};

export default GenericCard;
